module.exports = __webpack_public_path__ + "img/who_awards_illustration.5bcde3be.svg";